module.exports = __webpack_public_path__ + "img/70.status_soap.71e27124.svg";